import React, { useState, useEffect, useRef } from "react";
import "./home.css";
import PangiImg from "../assets/pangi-7.png";
import manaliImg from "../assets/manali.png";
import shimlaImg from "../assets/shimla.png";
import dharamshalaImg from "../assets/dharamshala.png";
import spitiImg from "../assets/spiti.png";
import dalhousieImg from "../assets/dalhousie.png";
import MeharChand from "../assets/MeharChand.jpg";
import KaraChand from "../assets/Karam.jpeg";
import TaraChand from "../assets/TaraChand.jpeg";
import { useNavigate, Link } from "react-router-dom";
import TestimonialsSection from "./TestimonialsSection";
import ImageSlider from "./ImageSlider";
import AnimatedImageViewer from "./AnimatedImageViewer";
import HomeHero from "./HomeHero";
import "matter-wrap";
import 'bootstrap-icons/font/bootstrap-icons.css';

// Import Matter.js and wrap plugin
import Matter from "matter-js";
import MatterWrap from "matter-wrap";

Matter.use(MatterWrap);
const SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbxVWJccOKi8rej-aA6dFJ70LVxRMfCDgDKhdCzsk-M2Pfc4iZi_xTyOoNKuyhgWzgtO/exec";
const sampleDrivers = [
  { name: "Mehar Chand", experience: 25, img: MeharChand },
  { name: "Tara Chand", experience: 12, img: TaraChand},
  { name: "Karam Chand", experience: 15, img: KaraChand},
];

const slides = [
  { img: manaliImg, title: "Manali", desc: "A stunning hill station surrounded by snow-capped peaks — perfect for adventure and honeymoon trips." },
  { img: shimlaImg, title: "Shimla", desc: "The Queen of Hills, known for colonial charm, serene beauty, and calm surroundings." },
  { img: dharamshalaImg, title: "Dharamshala", desc: "A peaceful blend of nature, spirituality, monasteries & Tibetan culture." },
  { img: dalhousieImg, title: "Dalhousie", desc: "A peaceful hill station with scenic views and colonial architecture." },
  { img: spitiImg, title: "Spiti Valley", desc: "Known for its high-altitude desert landscapes and ancient monasteries." },
  { img: PangiImg, title: "Pangi Valley", desc: "A hidden gem with rugged terrain, deep gorges, and vibrant culture." },
];

export default function Home() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();
  const canvasRef = useRef(null);
const [galleryImages, setGalleryImages] = useState([]);
const [galleryVideos, setGalleryVideos] = useState([]);
const [currentGalleryImage, setCurrentGalleryImage] = useState(0);
const getDirectStreamUrl = (url, type) => {
  if (!url) return "";

  if (url.startsWith("data:")) return url;

  if (!url.includes("drive.google.com") && !url.includes("http")) {
    if (type === "video" || type === "reel") {
      return `data:video/mp4;base64,${url}`;
    }
    return `data:image/jpeg;base64,${url}`;
  }

  if (url.includes("drive.google.com")) {
    const match =
      url.match(/\/d\/([^/]+)/) ||
      url.match(/[?&]id=([^&]+)/);

    if (match) {
      const id = match[1];

      if (type === "video" || type === "reel") {
        return `https://drive.google.com/file/d/${id}/preview`;
      }

      return `https://drive.google.com/thumbnail?id=${id}&sz=w1200`;
    }
  }

  return url;
};
useEffect(() => {
  fetch(`${SCRIPT_URL}?type=gallery`)
    .then((res) => res.json())
    .then((data) => {
      let items = [];

      if (Array.isArray(data))
        items = data;
      else if (data.gallery)
        items = data.gallery;
      else if (data.Gallery)
        items = data.Gallery;
      else if (data.data)
        items = data.data;
      else if (data.images)
        items = data.images;

      const imgs = [];
      const vids = [];

      items.forEach((item) => {
        
        const raw =
          typeof item === "string"
            ? item
            : item.Image ||
              item.image ||
              item.url ||
              item.URL ||
              item.mediaUrl ||
              "";

        const type =
          typeof item === "string"
            ? "image"
            : (
                item.Type ||
                item.type ||
                item.MediaType ||
                item.mediaType ||
                "image"
              ).toLowerCase();

        const media = getDirectStreamUrl(raw, type);

        if (!media) return;

        if (type === "video" || type === "reel") {
          vids.push({
  url: media,
  type: "video"
});
        } else {
          imgs.push(media);
        }
      });

      setGalleryImages(imgs.slice(0, 6));
      setGalleryVideos(vids.slice(0, 4));
    })
    .catch(console.error);
}, []);
  // Matter.js Floaty Bubbles Hook
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    // Config options matched with the original source script
    const options = {
      radiusRange: [50, 100],
      xVarianceRange: [-0.5, 0.5],
      yVarianceRange: [0.5, 1.5],
      airFriction: 0.03,
      opacity: 1,
      collisions: true,
      scrollVelocity: 0.025,
      pixelsPerBody: 50000,
      colors: ['#e4e4cc', '#e1d2c4', '#d1e4df']
    };

    let engine, render, runner;
    let bodies = [];
    let lastOffset = window.pageYOffset;
    let scrollTimeout = null;
    let resizeTimeout = null;

    const randomize = (range) => {
      let [min, max] = range;
      return Math.random() * (max - min) + min;
    };

    // Engine Lifecycle Methods
    const initPhysics = () => {
      let viewportWidth = document.documentElement.clientWidth;
      let viewportHeight = document.documentElement.clientHeight;

      engine = Matter.Engine.create();
      engine.world.gravity.y = 0;

      render = Matter.Render.create({
        canvas: canvas,
        engine: engine,
        options: {
          width: viewportWidth,
          height: viewportHeight,
          wireframes: false,
          background: 'transparent'
        }
      });
      Matter.Render.run(render);

      runner = Matter.Runner.create();
      Matter.Runner.run(runner, engine);

      bodies = [];
      let totalBodies = Math.round((viewportWidth * viewportHeight) / options.pixelsPerBody);

      for (let i = 0; i <= totalBodies; i++) {
        let x = randomize([0, viewportWidth]);
        let y = randomize([0, viewportHeight]);
        let radius = randomize(options.radiusRange);
        let color = options.colors[i % options.colors.length];

        let body = Matter.Bodies.circle(x, y, radius, {
          render: {
            fillStyle: color,
            opacity: options.opacity
          },
          frictionAir: options.airFriction,
          collisionFilter: {
            group: options.collisions ? 1 : -1
          },
          plugin: {
            wrap: {
              min: { x: 0, y: 0 },
              max: { x: viewportWidth, y: viewportHeight }
            }
          }
        });
        bodies.push(body);
      }
      Matter.World.add(engine.world, bodies);
    };

    const shutdownPhysics = () => {
      if (render) Matter.Render.stop(render);
      if (runner) Matter.Runner.stop(runner);
      if (engine) Matter.Engine.clear(engine);
    };

    // Initial load Execution
    initPhysics();

    // Event Handlers
    const onScroll = () => {
      scrollTimeout = null;
      let delta = (lastOffset - window.pageYOffset) * options.scrollVelocity;
      
      bodies.forEach((body) => {
        Matter.Body.setVelocity(body, {
          x: body.velocity.x + delta * randomize(options.xVarianceRange),
          y: body.velocity.y + delta * randomize(options.yVarianceRange)
        });
      });

      lastOffset = window.pageYOffset;
    };

    const onScrollThrottled = () => {
      if (!scrollTimeout) {
        scrollTimeout = setTimeout(onScroll, 100);
      }
    };

    const onResizeThrottled = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        shutdownPhysics();
        initPhysics();
      }, 400);
    };

    window.addEventListener('scroll', onScrollThrottled);
    window.addEventListener('resize', onResizeThrottled);

    // Master cleanup lifecycle hook
    return () => {
      clearTimeout(scrollTimeout);
      clearTimeout(resizeTimeout);
      window.removeEventListener('scroll', onScrollThrottled);
      window.removeEventListener('resize', onResizeThrottled);
      shutdownPhysics();
    };
  }, []);

  // High-Performance Scroll Trigger Reveal Hook
  useEffect(() => {
    const observerOptions = { 
      threshold: 0.15, 
      rootMargin: "0px 0px -80px 0px" 
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("reveal-visible");
        }
      });
    }, observerOptions);

    const animatedElements = document.querySelectorAll(
      ".reveal-fade, .reveal-left, .reveal-right, .reveal-zoom, .reveal-grid-cascade"
    );
    animatedElements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  // Hero Background slideshow
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);
useEffect(() => {
  if (galleryImages.length <= 1) return;

  const interval = setInterval(() => {
    setCurrentGalleryImage((prev) => (prev + 1) % galleryImages.length);
  }, 3500);

  return () => clearInterval(interval);
}, [galleryImages]);
  return (
    <div className="home">
      {/* Background Canvas Layer */}
      <canvas ref={canvasRef} className="global-bg-canvas" />

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-slider">
          <img src={slides[currentSlide].img} alt={slides[currentSlide].title} className="hero-bg-image" />
        </div>
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1 className="hero-fade-in-up delay-1">Mehar Tour & Travels</h1>
          <h2 className="hero-quote hero-fade-in-up delay-2">"Where every mountain peak has a story waiting to be discovered."</h2>
          <p className="hero-fade-in-up delay-3">From snowy valleys to peaceful lakes — discover handpicked destinations with unforgettable experiences.</p>
          <div className="hero-fade-in-up delay-4">
            <Link to="/tours-packages" className="hero-btn">Explore Packages</Link>
          </div>
        </div>
      </section>

      {/* Featured Places Section */}
      <section className="featured-places reveal-grid-cascade">
        <p className="title">Top Tourist Places</p>
        <p className="section-intro">
          Handpicked destinations curated specially for family trips, honeymoons, adventure tours, and pilgrimages.
        </p>

        <div className="place-grid">
          <div className="place-card reveal-card-item">
            <img src={manaliImg} alt="Manali" />
            <div className="place-info">
              <h3>Manali</h3>
              <p className="desc">A stunning hill station surrounded by snow-capped peaks and lush forests.</p>
              <ul>
                <li>• Solang Valley</li>
                <li>• Rohtang Pass</li>
                <li>• Atal Tunnel</li>
                <li>• Hadimba Temple</li>
              </ul>
            </div>
          </div>

          <div className="place-card reveal-card-item">
            <img src={shimlaImg} alt="Shimla" />
            <div className="place-info">
              <h3>Shimla</h3>
              <p className="desc">The Queen of Hills, known for colonial charm & serene beauty.</p>
              <ul>
                <li>• Mall Road</li>
                <li>• Kufri Snow Point</li>
                <li>• Jakhoo Temple</li>
                <li>• Ridge Ground</li>
              </ul>
            </div>
          </div>

          <div className="place-card reveal-card-item">
            <img src={dharamshalaImg} alt="Dharamshala" />
            <div className="place-info">
              <h3>Dharamshala</h3>
              <p className="desc">A peaceful blend of nature, spirituality & Tibetan culture.</p>
              <ul>
                <li>• McLeodganj</li>
                <li>• Tea Gardens</li>
                <li>• Triund Trek</li>
                <li>• Dalai Lama Temple</li>
              </ul>
            </div>
          </div>

          <div className="place-card reveal-card-item">
            <img src={spitiImg} alt="Spiti Valley" />
            <div className="place-info">
              <h3>Spiti Valley</h3>
              <p className="desc">The cold desert mountain valley known for monasteries & surreal landscapes.</p>
              <ul>
                <li>• Key Monastery</li>
                <li>• Chandratal Lake</li>
                <li>• Kaza</li>
                <li>• Pin Valley</li>
              </ul>
            </div>
          </div>

          <div className="place-card reveal-card-item">
            <img src={dalhousieImg} alt="Dalhousie" />
            <div className="place-info">
              <h3>Dalhousie</h3>
              <p className="desc">A British-era hill town with pine valleys, colonial charm & mountain views.</p>
              <ul>
                <li>• Khajjiar</li>
                <li>• Dainkund Peak</li>
                <li>• Panchpula</li>
                <li>• Satdhara Falls</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <ImageSlider />

      {/* Why Choose Us Section */}
      <section className="why-choose reveal-grid-cascade">
        <h1>Why Choose Us?</h1>
        <div className="why-grid">
          <div className="why-card reveal-card-item">
            <div className="card-inner">
              <div className="card-front">✔ Experienced Drivers</div>
              <div className="card-back">Our drivers have 10+ years of experience ensuring safe & smooth journeys.</div>
            </div>
          </div>

          <div className="why-card reveal-card-item">
            <div className="card-inner">
              <div className="card-front">✔ Affordable Tours</div>
              <div className="card-back">Best budget-friendly tour packages tailored to your needs.</div>
            </div>
          </div>

          <div className="why-card reveal-card-item">
            <div className="card-inner">
              <div className="card-front">✔ Customizable Trips</div>
              <div className="card-back">Modify routes, hotels, and schedules based on your preference.</div>
            </div>
          </div>

          <div className="why-card reveal-card-item">
            <div className="card-inner">
              <div className="card-front">✔ Verified Hotels</div>
              <div className="card-back">Stay in safe, hygienic, and verified hotels only.</div>
            </div>
          </div>
        </div>
        <HomeHero />
      </section>

      <TestimonialsSection />
      <section className="glimpses-section">

  {/* ---------- IMAGE SLIDER ---------- */}
  {galleryImages.length > 0 && (
    <div className="home-gallery-slider">

      {galleryImages.map((img, i) => (
        <img
          key={i}
          src={img}
          alt={`Gallery ${i}`}
          className={`home-slider-image ${
            i === currentGalleryImage ? "active" : ""
          }`}
        />
      ))}

      <div className="home-slider-dots">
        {galleryImages.map((_, i) => (
          <span
            key={i}
            className={`dot ${
              i === currentGalleryImage ? "active" : ""
            }`}
            onClick={() => setCurrentGalleryImage(i)}
          />
        ))}
      </div>

    </div>
  )}

 

</section>
      <AnimatedImageViewer />

      {/* Our Drivers Section */}
      <section className="drivers-section reveal-zoom">
        <h2>Meet Our Experienced Drivers</h2>
        <div className="drivers-grid" style={{ display: "flex", justifyContent: "center", alignContent: "center", gap: "30px", flexWrap: "wrap" }}>
          {sampleDrivers.map((d, index) => (
            <div className="driver-card" key={index}>
              <img src={d.img} alt={d.name} />
              <h3>{d.name}</h3>
              <p>{d.experience}+ Years Experience</p>
            </div>
          ))}
        </div>
      </section>
      <section class="contact-form">
  <h2>Get Free Tour Quote</h2>
  <form>
    <div class="form-group">
      <input type="text" placeholder="Your Name" required />
    </div>

    <div class="form-group">
      <input type="tel" placeholder="Phone Number" required />
    </div>

    <div class="form-group">
      <input type="text" placeholder="Destination" required />
    </div>

    <div class="form-group">
      <input type="number" placeholder="No. of People" min="1" required />
    </div>

    <div class="form-group">
      <textarea placeholder="Message" rows="4"></textarea>
    </div>

    <button type="submit">Submit</button>
  </form>
</section>
    </div>
  );
}